import React from 'react';

const EventGallery = () => {
  const galleryImages = [
    {
      src: "/NavigatingEntrepreneurship/Presenting.webp",
      alt: "Charly presenting",
      caption: "Presenting key entrepreneurial strategies to the audience",
      className: "w-full h-64 md:h-80 object-cover"
    },
    {
      src: "/NavigatingEntrepreneurship/deanandprogramdirector.webp",
      alt: "With Dean and Program Directors",
      caption: "With the Dean and Program Directors of the Faculty of Engineering",
      className: "w-full h-64 md:h-80 object-cover"
    }
  ];

  const auditoriumImage = {
    src: "/NavigatingEntrepreneurship/auditorium.webp",
    alt: "Auditorium view",
    caption: "Salón Cruz Pombo filled with engineering students and faculty",
    className: "w-full h-64 md:h-96 object-cover"
  };

  return (
    <section className="bg-white">
      <div className="pt-12 pb-12">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            {galleryImages.map((image, index) => (
              <div key={index} className="bg-white rounded-xl shadow-sm border border-apple-gray-200 overflow-hidden">
                <img
                  loading="lazy"
                  decoding="async"
                  src={image.src}
                  alt={image.alt}
                  className={image.className}
                />
                <div className="p-4">
                  <p className="text-apple-gray-600 text-sm">{image.caption}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Auditorium Image - Full width */}
          <div className="bg-white rounded-xl shadow-sm border border-apple-gray-200 overflow-hidden">
            <img
              loading="lazy"
              decoding="async"
              src={auditoriumImage.src}
              alt={auditoriumImage.alt}
              className={auditoriumImage.className}
            />
            <div className="p-4">
              <p className="text-apple-gray-600 text-sm">{auditoriumImage.caption}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventGallery;